<template>
  <div>
    <div class="main"
         :class="{'main-long': $store.state.footFlag === 0}"
         v-if="loading === 1 && dataList.length > 0">
      <div class="head">
        <h1 style="margin:50px 0px 15px 0px; font-weight:500;">장바구니</h1>
        <!-- <hr style="border-top: 1px solid rgba(0, 0, 0, 0.2);"> -->
        <div class="progress-div"
             v-if="storeDeliveryInfo.MIN_PROMO_COST !== null && storeDeliveryInfo.DELIVERY_COST !== null &&
            (Number(payValue) !== 7 && Number(payValue) !== 8)">
          <VueJsProgress :percentage="(totalValue / storeDeliveryInfo.MIN_PROMO_COST) * 100"
                         :minPromo="Number(storeDeliveryInfo.MIN_PROMO_COST)"
                         :delay="300"
                         :totalValue="totalValue"
                         :deliveryCost="storeDeliveryInfo.DELIVERY_COST"
                         :lackPromo="Number(storeDeliveryInfo.MIN_PROMO_COST) - Number(totalValue) < 0 ? 0 : Number(storeDeliveryInfo.MIN_PROMO_COST - totalValue)"
                         style="flex:10;"
                         bg="terypink" />
        </div>
        <div class="progress-div"
             v-else-if="$store.state.storeSeq === '053_00000104'">
          <VueJsProgress :percentage="(totalValue / storeDeliveryInfo.MIN_PROMO_COST) * 100"
                         :minPromo="Number(storeDeliveryInfo.MIN_PROMO_COST)"
                         :delay="300"
                         :totalValue="totalValue"
                         :deliveryCost="storeDeliveryInfo.DELIVERY_COST"
                         :lackPromo="Number(storeDeliveryInfo.MIN_PROMO_COST) - Number(totalValue) < 0 ? 0 : Number(storeDeliveryInfo.MIN_PROMO_COST - totalValue)"
                         style="flex:10;"
                         bg="terypink" />
        </div>
        <!-- <hr style="border-top: 1px solid rgba(0, 0, 0, 0.2);"> -->
        <!-- v-if="!$empty($store.state.addressList) && addrFlag" -->
        <div class="addr-div">
          <!-- <div class="addr-div1" style="align-items:center;justify-content:space-around;">
              <button class="addr-select-btn" v-if="!$empty($store.state.addressList)" @click="$modal.show('selectAddr')">배송지 선택</button>
              <button class="addr-add-btn" @click="addAddress">새로운 배송지</button>
            </div> -->
          <div class="addr-div-top">
            <div class="addr-div1">
              <div class="addr-div-title">
                <img src="@/assets/point_dot.png"
                     class="point-dot">
                전화번호
              </div>
              <div class="addr-div-content">
                <input type="number"
                       class="addr-div-input"
                       ref="phoneInput"
                       placeholder="'-' 없이 숫자만 입력하세요."
                       v-debounce:300="searchCustomer"
                       v-model="$store.state.customerPhone"
                       required>
              </div>
            </div>
            <div class="addr-div1">
              <div class="addr-div-title">
                <img src="@/assets/point_dot.png"
                     class="point-dot">
                이름
              </div>
              <div class="addr-div-content">
                <input type="text"
                       class="addr-div-input"
                       name="nameInput"
                       id="nameInput"
                       placeholder="이름을 입력해주세요."
                       :readonly="addrFlag"
                       v-model="$store.state.customerName"
                       required>
              </div>
            </div>
          </div>
          <div class="addr-div-middle">
            <div class="addr-div1"
                 style="height: 60px;">
              <div class="addr-div-title">
                <img src="@/assets/point_dot.png"
                     class="point-dot">
                받을주소
              </div>
              <div class="addr-div-content"
                   style="height: 60px;">
                <textarea rows="2"
                          class="addr-div-input"
                          style="resize: none;"
                          v-model="$store.state.fullAddr"
                          placeholder="주소를 검색하세요"
                          @click="openSearchModal"
                          required
                          readonly></textarea>
              </div>
            </div>
          </div>
          <div class="addr-div-bottom">
            <div class="addr-div1">
              <div class="addr-div-title"
                   style="justify-content: flex-start;align-items:flex-start;">
                요청사항
              </div>
              <div class="addr-div-content">
                <textarea class="addr-div-memo"
                          placeholder="기타 문의 사항이나 요청사항이 있으면 입력하세요"
                          @focus="$store.state.footFlag = 0"
                          @blur="$store.state.footFlag = 1"
                          v-model="$store.state.customerMemo"></textarea>
              </div>
            </div>
            <div class="pay-div">
              <div class="pay-div-left">
                <div class="pay-title-div">
                  수령방법
                </div>
              </div>
              <div class="pay-div-right">
                <div class="pay-div1"
                     v-if="(storeDeliveryInfo.PAYMENT_USE_FLAG === '1' && storeDeliveryInfo.result.type0 === '1') ||
                      $empty(storeDeliveryInfo.result.type1) || storeDeliveryInfo.result.type1 === '1' ||
                      $empty(storeDeliveryInfo.result.type2) || storeDeliveryInfo.result.type2 === '1'">
                  <input type="radio"
                         class="checkbox"
                         name="payType"
                         id="deliveryRadio"
                         value="0"
                         v-model="payType">
                  <label for="deliveryRadio"
                         class="input-label radio">
                    <span class="payRadioSelect"
                          :class="{'payRadioNotSelect': payType !== '0'}">
                      배달
                    </span>
                  </label>
                </div>
                <div class="pay-div1"
                     v-if="(storeDeliveryInfo.PAYMENT_USE_FLAG === '1' && storeDeliveryInfo.result.type3 === '1') ||
                      $empty(storeDeliveryInfo.result.type4) || storeDeliveryInfo.result.type4 === '1'">
                  <input type="radio"
                         class="checkbox"
                         name="payType"
                         id="packageRadio"
                         value="1"
                         v-model="payType">
                  <label for="packageRadio"
                         class="input-label radio">
                    <span class="payRadioSelect"
                          :class="{'payRadioNotSelect': payType !== '1'}">
                      포장
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <hr />
            <div class="pay-div">
              <div class="pay-div-left">
                <div class="pay-title-div">
                  결제방법
                </div>
              </div>
              <div class="pay-div-right">
                <div class="pay-div1"
                     v-if="storeDeliveryInfo.PAYMENT_USE_FLAG === '1' && storeDeliveryInfo.result.type0 === '1' && payType === '0'">
                  <input type="radio"
                         class="checkbox"
                         name="pay"
                         id="onlineCard"
                         value="1"
                         v-model="payValue">
                  <label for="onlineCard"
                         class="input-label radio">
                    <span class="payRadioSelect"
                          :class="{'payRadioNotSelect': payValue !== '1'}">
                      바로결제
                    </span>
                  </label>
                </div>
                <div class="pay-div1"
                     v-if="($empty(storeDeliveryInfo.result.type1) || storeDeliveryInfo.result.type1 === '1') && payType === '0'">
                  <input type="radio"
                         class="checkbox"
                         name="pay"
                         id="offlineCard"
                         value="5"
                         v-model="payValue">
                  <label for="offlineCard"
                         class="input-label radio">
                    <span class="payRadioSelect"
                          :class="{'payRadioNotSelect': payValue !== '5'}">
                      만나서 카드결제
                    </span>
                  </label>
                </div>
                <div class="pay-div1"
                     v-if="($empty(storeDeliveryInfo.result.type2) || storeDeliveryInfo.result.type2 === '1') && payType === '0'">
                  <input type="radio"
                         class="checkbox"
                         name="pay"
                         id="offlineCash"
                         value="6"
                         v-model="payValue">
                  <label for="offlineCash"
                         class="input-label radio">
                    <span class="payRadioSelect"
                          :class="{'payRadioNotSelect': payValue !== '6'}">
                      만나서 현금결제
                    </span>
                  </label>
                </div>
                <div class="pay-div1"
                     v-if="storeDeliveryInfo.PAYMENT_USE_FLAG === '1' && storeDeliveryInfo.result.type3 === '1' && payType === '1'">
                  <input type="radio"
                         class="checkbox"
                         name="pay"
                         id="toVisitPayment"
                         value="8"
                         v-model="payValue">
                  <label for="toVisitPayment"
                         class="input-label radio">
                    <span class="payRadioSelect"
                          :class="{'payRadioNotSelect': payValue !== '8'}">
                      바로결제
                    </span>
                  </label>
                </div>
                <div class="pay-div1"
                     v-if="($empty(storeDeliveryInfo.result.type4) || storeDeliveryInfo.result.type4 === '1') && payType === '1'">
                  <input type="radio"
                         class="checkbox"
                         name="pay"
                         id="toVisit"
                         value="7"
                         v-model="payValue">
                  <label for="toVisit"
                         class="input-label radio">
                    <span class="payRadioSelect"
                          :class="{'payRadioNotSelect': payValue !== '7'}">
                      만나서 결제
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body"
           v-if="loading === 1"
           style="background:#FFF8F8;">
        <div style="display:flex;height:50px;width:100%;justify-content: center;align-item:center;background:#FFF8F8;">
          <div style="flex:1; display:flex;align-items:center;justify-content:flex-start;">
            <input ref="allCheck"
                   type="checkbox"
                   id="allCheck"
                   @click="checkAll"
                   v-model="allCheck">
            <label for="allCheck"></label>
            전체선택
          </div>
          <div style="height: 100%; flex:1; display:flex; align-items:center; justify-content: flex-end;">
            <button v-if="selectProduct.length > 0"
                    class="deleteBtn"
                    @click="removeBasket">선택삭제</button>
          </div>
        </div>
        <div v-for="(seq, index1) in storeSeqList"
             :key="index1"
             class="productByStore">
          <div v-for="(row, index2) in dataList"
               :key="index2">
            <div v-if="row.store_seq === seq || row.storeSeq === seq"
                 class="productDiv">
              <input type="checkbox"
                     :id="`productChk${index2}`"
                     :refs="`productChk${index2}`"
                     name="productChk"
                     class="productCheckbox"
                     @click="checkProduct(row)">
              <label :for="`productChk${index2}`"></label>
              <div class="productImgDiv">
                <div class="productBadgeDiv"
                     v-if="!$empty(row.badgeInfo) || (!$empty(row.badgeList) && row.badgeList.length > 0)">
                  <!-- <img :src="`${row.badgeInfo.imageUrl}`" style="width: 30%; max-width: 100px;" v-if="!$empty(row.badgeInfo.imageUrl)"> -->
                  <img :src="`${row.badgeInfo.imageUrl}`"
                       v-if="!$empty(row.badgeInfo.imageUrl) && ($empty(row.badgeList) || row.badgeList.length === 0)"
                       class="badge-image"
                       alt="">
                  <img v-if="!$empty(row.badgeList) && row.badgeList.length > 0"
                       :src="row.badgeList[0].imageUrl"
                       class="badge-image"
                       alt="" />
                  <img v-if="!$empty(row.badgeList) && row.badgeList.length > 1"
                       :src="row.badgeList[1].imageUrl"
                       class="badge-image badge-image--1"
                       alt="" />
                  <img v-if="!$empty(row.badgeList) && row.badgeList.length > 2"
                       :src="row.badgeList[2].imageUrl"
                       class="badge-image badge-image--2"
                       alt="" />
                </div>
                <div class="imageDivInner">
                  <img :src="row.imageUrl"
                       class="productImg"
                       v-if="!$empty(row.imageUrl)"
                       @error="errorImage">
                  <img :src="row.image_url"
                       class="productImg"
                       v-else-if="!$empty(row.image_url)"
                       @error="errorImage">
                  <img :src="row.IMAGE_URL"
                       class="productImg"
                       v-else-if="!$empty(row.IMAGE_URL)"
                       @error="errorImage">
                  <img src="@/assets/no_item_image.png"
                       class="productImg"
                       v-else />
                </div>
              </div>
              <div class="productContent">
                <div class="nameDiv"
                     style="font-size: 16px;">
                  <!-- 상품명 -->
                  <span class="product-name"
                        v-if="row.name.length <= 10">
                    {{row.name}}{{row.status !== 2 ? changeStatus(row.status) : ' '}}
                  </span>
                  <marquee-text :duration="5"
                                v-else>{{row.name}}{{row.status !== 2 ? changeStatus(row.status) : ' '}}&emsp;</marquee-text>
                </div>
                <div class="eventDayDiv"
                     v-if="!$empty(row.app_price) && row.app_price > 0">
                  <!-- 할인률 및 행사기간-->
                  <div @click="moveToApp"
                       style="flex:1; cursor: point;">
                    <span style="color:#F67E27; font-size: 14px;">
                      {{ numberWithCommas(Number(row.sell_price) - Number(row.app_price)) + ' 할인 앱 행사가 상품' }}
                    </span>
                  </div>
                </div>
                <div class="eventDayDiv"
                     v-else-if="row.cost_price > 0 && row.cost_price > row.sell_price">
                  <!-- 할인률 및 행사기간-->
                  <div style="flex:1;">
                    <span style="color:#F67E27; font-size: 14px;">
                      {{ Math.round((1 - (row.sell_price / row.cost_price)) * 100) + '%할인 행사상품' }}
                    </span>
                  </div>
                </div>
                <div class="nameDiv"
                     style="margin:0;">
                  <span style="color:#2d2d2d;font-size:20px;">
                    {{numberWithCommas(row.sell_price, 1)}}
                  </span>
                </div>
                <div class="storeNameDiv">
                  <!-- 매장명 -->
                  <span style="font-size: 13px;color:#b4b4b4;">
                    {{returnStoreName(row.storeSeq)}}
                  </span>
                </div>
                <div class="nameDiv"
                     v-if="!$empty(row.standard)">
                  <!-- 규격 -->
                  <span>
                    {{row.standard}}
                  </span>
                </div>
                <div class="quantityDiv">
                  <!-- 수량조절 및 정상가, 판매가 -->
                  <div class="quantityDiv-inner">
                    <button class="basket-delete-btn"
                            @click="deleteBasket(row)">삭제</button>
                  </div>
                  <div class="quantityDiv-inner">
                    <button type="button"
                            class="quantityBtn"
                            @click="changeQuantity(index2, 'm')">-</button>
                    <input type="number"
                           class="quantityInput"
                           :value="row.order_qty" />
                    <button type="button"
                            class="quantityBtn"
                            @click="changeQuantity(index2, 'p')">+</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="foot-open-btn-open"
           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 1 && deliveryCharge > 0">
        <span class="delivery-cost-span">배달료: {{numberWithCommas(deliveryCharge, 1)}} 포함</span>
      </div>
      <div class="foot-bar-basket"
           v-if="Number($store.state.storeInfo.DELIVERY_FLAG) === 1">
        <div class="totalPrice-div">
          <span class="totalPrice">
            &nbsp;{{totalPrice}}
          </span>
          <span style="font-weight: 500;font-size: 16px;color: #2d2d2d;line-height:25px;">원</span>
        </div>
        <div style="flex: 3;color:#2d2d2d;align-items:center;justify-content:flex-end;display:flex;">
          <button class="orderBtn"
                  v-if="deliveryFlag === 1 && Number(payValue) !== 7 && Number(payValue) !== 8"
                  @click="chkProductState(1)">배달주문</button>
          <button class="orderBtn"
                  v-else-if="deliveryFlag === 1"
                  @click="chkProductState(1)">포장주문</button>
          <button class="orderBtn-not"
                  @click="impossibleOrder"
                  v-else>주문</button>
        </div>
      </div>
      <modal name="insertPhone"
             class="selectAddr"
             :width="'95%'"
             :height="200"
             :clickToClose="false">
        <div class="selectAddr-main"
             style="padding: 0px;">
          <div class="selectAddr-top">
            <h2 class="selectAddr-top-title">받으실 분</h2>
            <span style="font-size: 30px; font-weight: 700;"
                  @click="$modal.hide('insertPhone')">×</span>
          </div>
          <div class="selectAddr-body">
            <div class="addr-div1">
              <div class="addr-div-title">
                전화번호
              </div>
              <div class="addr-div-content">
                <input type="number"
                       class="addr-div-input"
                       ref="phoneInput2"
                       placeholder="'-' 없이 숫자만 입력하세요."
                       v-debounce:300="searchCustomer"
                       v-model="$store.state.customerPhone"
                       required>
              </div>
            </div>
          </div>
          <div class="selectAddr-foot">
            <button class="confirm-btn"
                    @click="[$modal.hide('insertPhone'), searchCustomer()]">확인</button>
          </div>
        </div>
      </modal>
      <modal name="selectAddr"
             class="selectAddr"
             :width="'95%'"
             :height="400"
             :clickToClose="false">
        <div class="selectAddr-main">
          <div class="selectAddr-top">
            <h2 class="selectAddr-top-title">배송지선택</h2>
            <span style="font-size: 30px; font-weight: 700;"
                  @click="addAddress">×</span>
          </div>
          <div class="selectAddr-body">
            <div class="addr-div-main"
                 v-for="(row, index) in $store.state.addressList"
                 :key="index"
                 @click="setAddress(row, index)">
              <div class="addr-left">
                <input type="radio"
                       class="checkbox"
                       name="selectRadio"
                       :id="`addrList${index}`"
                       :value="index"
                       v-model="addressIndex">
                <label :for="`addrList${index}`"
                       class="input-label radio">
                  <span class="payRadioSelect"
                        :class="{'payRadioNotSelect': addressIndex !== index}">
                    {{row.RECEIVE_NAME}}
                  </span>
                </label>
              </div>
              <div class="addr-right">
                {{row.RECEIVE_ADDRESS}} {{row.RECEIVE_ADDRESS_DETAIL}}
              </div>
            </div>
          </div>
          <div class="selectAddr-foot">
            <button class="add-new-btn"
                    @click="addAddress">새로운배송지</button>
            <button class="confirm-btn"
                    @click="confirmAddress">확인</button>
          </div>
        </div>
      </modal>
      <modal name="searchAddr"
             class="searchAddr"
             :width="'95%'"
             :height="'80%'"
             :clickToClose="false">
        <div class="searchAddr-main"
             v-if="searchIndex === 0">
          <div class="searchAddr-top">
            <div style="font-size: 30px; font-weight: 700;"
                 @click="searchBack">
              <img src="@/assets/icon/btn_arrow.svg" />
            </div>
            <h2 class="searchAddr-top-title">받을 주소</h2>
          </div>
          <div class="searchAddr-body">
            <div class="searchAddr-body-search">
              <input type="text"
                     ref="searchAddrInput"
                     class="searchAddr-div-input"
                     placeholder="지번, 도로명으로 검색"
                     v-model="clickAddress"
                     @input="searchAddress" />
            </div>
            <div class="searchAddr-body-search-list">
              <div class="searchAddr-body-search-list-content"
                   v-for="(row, index) in addressList"
                   :key="index"
                   @click="selectRoadAddress(row.addr)">
                <div>우편번호 : {{row.zipCode}}</div>
                <div>
                  <span>주&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;소 : </span><span v-html="row.addr"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="searchAddr-main"
             v-else>
          <div class="searchAddr-top">
            <div style="font-size: 30px; font-weight: 700;"
                 @click="searchBack">
              <img src="@/assets/icon/btn_arrow.svg" />
            </div>
            <h2 class="searchAddr-top-title">받을 주소</h2>
          </div>
          <div class="searchAddr-body2">
            <div style="height: 40px;">{{$store.state.addr1}}</div>
            <div class="searchAddr-body-search">
              <input type="text"
                     class="searchAddr-div-input2"
                     v-model="$store.state.addr2"
                     placeholder="상세주소입력" />
            </div>
          </div>
          <div class="searchAddr-foot">
            <button class="done-btn"
                    @click="searchDoneAddress">완료</button>
          </div>
        </div>
      </modal>
    </div>
    <div class="main"
         style="text-align:center; margin-top: 75px; background: white;"
         v-else>
      <img src="@/assets/cart.png"
           class="blankCart">
      <div>
        <span style="color:#878787;margin:0px 0px 0px 0px;">장바구니에</span><br>
      </div>
      <div>
        <span style="color:#878787;margin:0px 0px 0px 0px;"> 담긴상품이 없습니다.</span>
      </div>
      <div>
        <button @click="goHome"
                class="goHome">홈으로 가기</button>
      </div>
    </div>
    <form ref="payment2"
          id="payment2"
          name="payment2"
          method="post">
      <!-- <input type="hidden" name="mchtId" value="nxca_jt_il"> -->
      <input type="hidden"
             name="mchtId"
             value="tono2">
      <input type="hidden"
             name="method"
             value="card">
      <input type="hidden"
             name="trdDt">
      <input type="hidden"
             name="trdTm">
      <input type="hidden"
             name="mchtTrdNo">
      <input type="hidden"
             name="mchtName">
      <input type="hidden"
             name="mchtEName">
      <input type="hidden"
             name="mchtParam">
      <input type="hidden"
             name="pmtPrdtNm">
      <input type="hidden"
             name="trdAmt">
      <input type="hidden"
             name="mchtCustNm">
      <input type="hidden"
             name="notiUrl"
             value="https://sery.co.kr/payment2Noti">
      <!-- <input type="hidden" name="notiUrl" value="http://211.208.9.210:9090/payment2Noti"> -->
      <input type="hidden"
             name="nextUrl">
      <input type="hidden"
             name="cancUrl">
    </form>
  </div>
</template>
<script>
import async from 'async';
// import VueJsProgress from 'vue-js-progress'
import VueJsProgress from '@/components/shareComponent/VueJsProgress';
import { loginWithKakao } from '@/components/publicFunc/public';
import * as mutations from '@/graphql/mutations';
import { API, graphqlOperation } from 'aws-amplify';
import { components } from 'aws-amplify-vue';
import axios from 'axios';
import _ from 'lodash';
export default {
  name: 'productBasket',
  components: {
    VueJsProgress,
    components,
  },
  metaInfo() {
    return {
      title: `장바구니 | 스마트전단 - ${this.$store.state.storeInfo.STORE_NAME}`,
    };
  },
  data() {
    return {
      dataList: [],
      storeSeqList: [],
      // storeInfoList: {},
      selectProduct: [],
      loading: 0,
      allCheck: false,
      totalValue: 0,
      deliveryCharge: 0,
      deliveryFlag: 0,
      payValue: this.$store.state.storeDeliveryInfo.PAYMENT_USE_FLAG !== '1' ? '5' : '1',
      payType: '0',
      addressIndex: '',
      selectAddress: '',
      selectWidth: 0,
      addrFlag: true,
      addressPage: 1,
      addressList: [],
      searchIndex: 0,
      clickAddress: '',
      customerPhone: '',
      // key: ''
    };
  },
  computed: {
    key: {
      get() {
        return this.$store.state.key;
      },
      set(key) {
        return key;
      },
    },
    storeDeliveryInfo() {
      return this.$store.state.storeDeliveryInfo;
    },
    storeSeq() {
      return this.$store.state.storeSeq;
    },
    totalPrice() {
      return this.numberWithCommas(this.totalValue + this.deliveryCharge, 0);
    },
    // payValue () {
    //   return this.$store.state.storeDeliveryInfo.PAYMENT_USE_FLAG !== 1 ? '5' : '1'
    // }
  },
  watch: {
    customerPhone() {
      this.customerPhone = this.customerPhone.replace(/[^0-9]/g, '');
      this.$store.state.customerPhone = this.customerPhone;
    },
    key() {
      const vm = this;
      this.getBasket();
      if (!vm.$empty(vm.$cookies.get('userSeq')) || !vm.$empty(vm.$cookies.get('userData'))) {
        if (!vm.$empty(vm.$cookies.get('userSeq')) && vm.$cookies.get('userSeq') !== 'undefined') {
          vm.$nextTick(() => {
            vm.getAddress(vm.$cookies.get('userSeq'));
          });
        } else if (!vm.$empty(vm.$cookies.get('userData'))) {
          var userData = vm.$cookies.get('userData');
          vm.$nextTick(() => {
            vm.getAddress(userData.USER_SEQ);
          });
        } else {
          console.log('사용자 데이터 없음 ::::: 1');
        }
      } else {
        console.log('사용자 데이터 없음 ::::: 2');
      }
      this.$nextTick(() => {
        console.log(this.$refs.allCheck);
        this.$store.state.addr1 = '';
        this.$store.state.addr2 = '';
        this.$store.state.customerName = '';
        this.$store.state.customerPhone = '';
        this.$store.state.customerMemo = '';
        this.$refs.allCheck.click();
      });
    },
    loading() {
      const vm = this;
      console.log('go home :::::', vm.loading, vm.dataList.length);
      if (vm.dataList.length === 0) {
        setTimeout(() => {
          vm.moveRouter('storeMain');
        }, 5000);
      }
    },
    payValue() {
      const vm = this;
      if ((vm.payValue === '7' || vm.payValue === 7 || vm.payValue === '8' || vm.payValue === 8) && vm.$store.state.storeSeq !== '053_00000104') {
        vm.deliveryFlag = 1;
        vm.deliveryCharge = 0;
      } else {
        vm.getTotal();
      }
    },
    payType() {
      const vm = this;
      if (vm.payValue === '7' || vm.payValue === '8') {
        if (vm.storeDeliveryInfo.PAYMENT_USE_FLAG === '1' && vm.storeDeliveryInfo.result.type0 === '1') {
          vm.payValue = '1';
        } else {
          vm.payValue = '5';
        }
      } else if (vm.payValue === '1' || vm.payValue === '5' || vm.payValue === '6') {
        if (vm.storeDeliveryInfo.PAYMENT_USE_FLAG === '1' && vm.storeDeliveryInfo.result.type3 === '1') {
          vm.payValue = '8';
        } else {
          vm.payValue = '7';
        }
      }
    },
  },
  mounted() {
    const vm = this;
    console.log('mounted::', this.$options.name);
    vm.$cookies.set('nowPage', 'productBasket');
    if (!vm.$empty(vm.key)) {
      vm.getBasket();
    }
    if (!vm.$empty(vm.$cookies.get('userSeq')) || !vm.$empty(vm.$cookies.get('userData'))) {
      if (!vm.$empty(vm.$cookies.get('userSeq')) && vm.$cookies.get('userSeq') !== 'undefined') {
        vm.$nextTick(() => {
          vm.getAddress(vm.$cookies.get('userSeq'));
        });
      } else if (!vm.$empty(vm.$cookies.get('userData'))) {
        var userData = vm.$cookies.get('userData');
        vm.$nextTick(() => {
          vm.getAddress(userData.USER_SEQ);
        });
      } else {
        console.log('사용자 데이터 없음');
        vm.$nextTick(() => {
          vm.$modal.show('insertPhone');
          const phone = vm.$refs.phoneInput2;
          if (!vm.$empty(phone)) {
            console.log('addAddress :::::');
            phone.focus();
          }
        });
      }
    } else {
      console.log('사용자 데이터 없음');
      vm.$nextTick(() => {
        vm.$modal.show('insertPhone');
        const phone = vm.$refs.phoneInput2;
        if (!vm.$empty(phone)) {
          console.log('addAddress :::::');
          phone.focus();
        }
      });
    }
    if (!vm.$empty(vm.dataList)) {
      vm.$nextTick(() => {
        console.log('allCheck :::::', vm.$refs.allCheck);
        vm.$store.state.addr1 = '';
        vm.$store.state.addr2 = '';
        vm.$store.state.customerName = '';
        vm.$store.state.customerPhone = '';
        vm.$store.state.customerMemo = '';
        vm.$refs.allCheck.click();
      });
    }
    if (vm.$empty(vm.$store.state.addressList)) {
      vm.$nextTick(() => {
        vm.addAddress();
      });
    }
    // 결제방식 기본값 설정
    if (vm.storeDeliveryInfo.result.type0 === '1') {
      vm.payType = '0';
      vm.payValue = '1';
    } else if (vm.storeDeliveryInfo.result.type1 === '1') {
      vm.payType = '0';
      vm.payValue = '5';
    } else if (vm.storeDeliveryInfo.result.type2 === '1') {
      vm.payType = '0';
      vm.payValue = '6';
    } else if (vm.storeDeliveryInfo.result.type3 === '1') {
      vm.payType = '1';
      vm.payValue = '8';
    } else if (vm.storeDeliveryInfo.result.type4 === '1') {
      vm.payType = '1';
      vm.payValue = '7';
    }
  },
  methods: {
    /**
     * 2021.06.28 비회원 주문 기능 추가 박상훈
     */
    // cancelNewAddr () {
    //   var store = this.$store.state
    //   this.addrFlag = true
    //   this.selectAddress = ''
    //   store.customerName = ''
    //   store.customerPhone = ''
    //   store.addr1 = ''
    //   store.addr2 = ''
    // },
    getAddress(seq) {
      console.log('getAddress :::::');
      this.$axios({
        method: 'get',
        url: `${process.env.API}/getAddress/id/${seq}`,
      }).then((response) => {
        if (response.data !== 'empty') {
          console.log('getAddress :::::', response.data);
          this.$store.state.addressList = this.$_.cloneDeep(response.data);
          this.$modal.show('selectAddr');
        }
      });
    },
    setAddress(row, index) {
      const vm = this;
      vm.addressIndex = index;
      this.selectAddress = this.$_.cloneDeep(row);
      var store = vm.$store.state;
      var addr = vm.selectAddress;
      this.addrFlag = true;
      if (!vm.$empty(addr.USER_SEQ)) {
        localStorage.setItem(`${vm.$route.query.seq}_userSeq`, addr.USER_SEQ);
        vm.$cookies.set('userSeq', addr.USER_SEQ);
      }
      store.customerName = addr.RECEIVE_NAME;
      store.customerPhone = addr.RECEIVE_PHONE1;
      store.zipCode = addr.ZIP_CODE;
      store.addr1 = addr.RECEIVE_ADDRESS;
      store.addr2 = addr.RECEIVE_ADDRESS_DETAIL;
      store.fullAddr = addr.RECEIVE_ADDRESS + ' ' + addr.RECEIVE_ADDRESS_DETAIL;
    },
    confirmAddress() {
      if (!this.$empty(this.selectAddress)) {
        this.$modal.hide('selectAddr');
      } else {
        alert('배송지를 선택해주세요.');
      }
    },
    async addAddress() {
      const vm = this;
      vm.$modal.hide('selectAddr');
      vm.addrFlag = false;
      vm.selectAddress = {};
      var store = vm.$store.state;
      store.addr1 = '';
      store.addr2 = '';
      // alert('배송지를 입력해주세요.')
      const phone = vm.$refs.phoneInput;
      if (!vm.$empty(phone)) {
        console.log('addAddress :::::');
        phone.focus();
      }
    },
    async insertOrder() {
      const vm = this;
      if (vm.$empty(vm.$store.state.customerName)) {
        alert('이름을 입력해 주세요');
      } else if (vm.$empty(vm.$store.state.customerPhone)) {
        alert('전화번호를 입력해 주세요');
      } else if (vm.$store.state.customerPhone.length < 10) {
        alert('최소 10자리 이상이어야합니다.');
      } else if (vm.$empty(vm.$store.state.addr1)) {
        alert('주소를 입력해 주세요');
      } else if (vm.$empty(vm.payValue)) {
        alert('결제방법을 선택해 주세요.');
      } else if (!vm.$empty(vm.dataList) && vm.dataList.findIndex((x) => x.status === 0 || x.status === 1) !== -1) {
        alert(`주문 할 수 없는 상품이 있습니다.\n 확인해주세요.`);
      } else if (vm.$empty(vm.selectProduct)) {
        alert('선택된 상품이 없습니다.');
      } else if (vm.getOverBadgeQtyLimitItem(vm.selectProduct)) {
        const over = vm.getOverBadgeQtyLimitItem(vm.selectProduct);
        vm.checkAndAlertBadgeQtyLimit(over, over.order_qty);
      } else {
        // 배달가능 최대범위 확인
        if (!vm.$empty(vm.$store.state.storeDeliveryInfo.maxDistance) && vm.$store.state.storeDeliveryInfo.maxDistance > 0) {
          // 배송거리 확인
          const check = await deliveryDistanceCheck(vm.$route.query.seq, vm.$store.state.storeDeliveryInfo.maxDistance, vm.$store.state.addr1);
          if (!check && !vm.$empty(vm.$store.state.storeDeliveryInfo.outRangeFlag) && vm.$store.state.storeDeliveryInfo.outRangeFlag === '0') {
            alert('죄송합니다.\n배달가능한 지역이 아닙니다.\n매장에 방문 부탁드립니다.');
            vm.$gtag.event('주문_불가', {
              event_category: vm.$route.query.seq,
              event_label: 'no',
              value: vm.$cookies.get('userSeq'),
            });
          } else if (!check) {
            let distanceConfirm = confirm('배달가능한 지역이 아닌경우 매장 사정에 의해 주문이 취소될 수 있습니다.\n이 점 양해 부탁드립니다.\n계속 주문하시겠습니까?');
            if (distanceConfirm) {
              order();
            } else {
              vm.$gtag.event('주문_선택_아니요', {
                event_category: vm.$route.query.seq,
                event_label: 'no',
                value: vm.$cookies.get('userSeq'),
              });
            }
          } else {
            let preConfirm = confirm('주문하시겠습니까?');
            if (preConfirm) {
              order();
            } else {
              vm.$gtag.event('주문_선택_아니요', {
                event_category: vm.$route.query.seq,
                event_label: 'no',
                value: vm.$cookies.get('userSeq'),
              });
            }
          }
        } else {
          let preConfirm = confirm('주문하시겠습니까?');
          if (preConfirm) {
            order();
          } else {
            vm.$gtag.event('주문_선택_아니요', {
              event_category: vm.$route.query.seq,
              event_label: 'no',
              value: vm.$cookies.get('userSeq'),
            });
          }
        }
      }
      async function order() {
        vm.$store.state.isLoading = true;
        try {
          let deliveryInfo = {};
          let userSeq = '';
          if (vm.$empty(vm.selectAddress)) {
            let chkDuplicate = await chkDuplicateNum();
            userSeq = Number(chkDuplicate.userSeq);
            deliveryInfo = {
              deliverySeq: chkDuplicate.deliveryInfo.DELIVERY_SEQ,
              failCode: '',
              receiveAddress: chkDuplicate.deliveryInfo.RECEIVE_ADDRESS,
              receiveAddressDetail: chkDuplicate.deliveryInfo.RECEIVE_ADDRESS_DETAIL,
              receiveName: chkDuplicate.deliveryInfo.RECEIVE_NAME,
              zipCode: chkDuplicate.deliveryInfo.ZIP_CODE,
              receivePhone1: chkDuplicate.deliveryInfo.RECEIVE_PHONE1,
              receivePhone2: chkDuplicate.deliveryInfo.RECEIVE_PHONE2,
              regDate: chkDuplicate.deliveryInfo.REG_DATE,
              result: '',
              useFlag: chkDuplicate.deliveryInfo.USE_FLAG,
              userSeq: chkDuplicate.deliveryInfo.USER_SEQ,
              inApp: false,
            };
            vm.$cookies.set('userSeq', Number(chkDuplicate.userSeq));
          } else {
            deliveryInfo = {
              deliverySeq: vm.selectAddress.DELIVERY_SEQ,
              failCode: '',
              receiveAddress: vm.selectAddress.RECEIVE_ADDRESS,
              receiveAddressDetail: vm.selectAddress.RECEIVE_ADDRESS_DETAIL,
              receiveName: vm.selectAddress.RECEIVE_NAME,
              zipCode: vm.selectAddress.ZIP_CODE,
              receivePhone1: vm.selectAddress.RECEIVE_PHONE1,
              receivePhone2: vm.selectAddress.RECEIVE_PHONE2,
              regDate: vm.selectAddress.REG_DATE,
              result: '',
              useFlag: vm.selectAddress.USE_FLAG,
              userSeq: vm.selectAddress.USER_SEQ,
              inApp: false,
            };
            userSeq = Number(vm.selectAddress.USER_SEQ);
            if (vm.$empty(userSeq) || userSeq === 'undefined') {
              localStorage.setItem(`${vm.$route.query.seq}_userSeq`, userSeq);
            }
            vm.$cookies.set('userSeq', Number(vm.selectAddress.USER_SEQ));
          }
          vm.$gtag.event('주문_선택_예', {
            event_category: vm.$route.query.seq,
            event_label: 'yes',
            value: vm.$cookies.get('userSeq'),
          });
          if (vm.$empty(deliveryInfo.receiveAddress)) {
            deliveryInfo = {
              receiveAddress: vm.$store.state.addr1,
              receiveAddressDetail: vm.$store.state.addr2,
              receiveName: vm.$store.state.customerName,
              receivePhone1: vm.$store.state.customerPhone,
              receivePhone2: vm.$store.state.customerPhone,
              userSeq: userSeq,
              inApp: false,
            };
          }

          var now = vm.$dayjs().unix();
          var uuid = `${!vm.$empty(vm.$cookies.get('orderSeq')) ? `${vm.$cookies.get('orderSeq')}` : `${now}-${vm.getUUID()}`}`;
          // ex) 051_00000008-123789123 (storeSeq + vm.$dayjs().unix())
          var orderNo = `${!vm.$empty(vm.$cookies.get('orderNo')) ? vm.$cookies.get('orderNo') : `${vm.$route.query.seq}-${now}`}`;
          var userName = deliveryInfo.receiveName;
          var productBasket = vm.$_.cloneDeep(vm.dataList);
          var product = vm.$_.cloneDeep(vm.selectProduct);
          var storeSeq = vm.$route.query.seq;
          var storeName = vm.$store.state.storeInfo.STORE_NAME;
          var paymentType = vm.payValue;
          var work1 = await preWork();
          console.log('preWork end :::::', work1);
          var obj = {};
          if (Number(vm.payValue) === 1 || Number(vm.payValue) === 8) {
            // 카드결제
            localStorage.setItem(`${vm.key}_paymentCard`, {});
            if (!vm.$empty(work1)) {
              obj = {
                orderSeq: `${uuid}`,
                storeSeq: storeSeq,
                userSeq: userSeq,
                deliveryInfo: JSON.stringify(deliveryInfo),
                orderDate: vm.$dayjs().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                paymentType: Number(vm.payValue),
                deliveryType: 0,
                memo: vm.$store.state.customerMemo,
                orderPrice: Number(vm.totalValue) + Number(vm.deliveryCharge),
                deliveryPrice: Number(vm.deliveryCharge),
                orderState: 0,
                deliveryName: '',
                deliveryCode: 0,
                deliveryNo: '',
                receiveCode: '',
                detailInfo: work1,
                storeName: vm.$store.state.storeInfo.STORE_NAME,
                userName: userName,
                minPromoCost: vm.$store.state.storeDeliveryInfo.MIN_PROMO_COST,
                cancelReason: '',
                cancelReasonDetail: '',
              };
              var order = await API.graphql(
                graphqlOperation(mutations.createSeryOrderInfo, {
                  input: obj,
                })
              );
              if (!vm.$empty(order)) {
                const payemntInfo = {};
                payemntInfo.deliveryInfo = deliveryInfo;
                payemntInfo.userSeq = userSeq;
                payemntInfo.now = now;
                payemntInfo.uuid = uuid;
                payemntInfo.orderNo = orderNo;
                payemntInfo.userName = userName;
                payemntInfo.productBasket = productBasket;
                payemntInfo.product = product;
                payemntInfo.storeSeq = storeSeq;
                payemntInfo.storeName = storeName;
                payemntInfo.paymentType = paymentType;
                payemntInfo.eventSeq = !vm.$empty(vm.$route.query.eventSeq) ? vm.$route.query.eventSeq : '';
                payemntInfo.obj = obj;
                localStorage.setItem(`${vm.key}_paymentCard`, JSON.stringify(payemntInfo));
                // 카드
                const payment = document.getElementById('payment2');
                // 요청일자
                payment.children[2].value = vm.$dayjs().format('YYYYMMDD');
                // 요청시간
                payment.children[3].value = vm.$dayjs().format('HHmmss');
                // 상점주문번호
                payment.children[4].value = uuid;
                // 상점한글명
                payment.children[5].value = '[WEB]' + storeName;
                // 상점영문명
                payment.children[6].value = 'Tonovation';
                // 매장순번
                payment.children[7].value = storeSeq;
                // 상품명
                let itemName = product[0].name;
                if (product.length > 1) {
                  let qty = product.length - 1;
                  if (qty > 0 && itemName.length < 50) {
                    itemName += `외 ${qty} 건`;
                  } else if (qty > 0) {
                    itemName += `${itemName.substring(0, 35)}...외 ${qty} 건`;
                  }
                }
                payment.children[8].value = itemName;
                // 거래금액
                payment.children[9].value = Number(vm.totalValue) + Number(vm.deliveryCharge);
                // 고객명
                payment.children[10].value = userSeq;
                if (!vm.$empty(vm.$route.query.eventSeq)) {
                  // 결제성공 시 이동 페이지
                  payment.children[12].value = `https://sery.co.kr/payment2Web?host=${location.host}&url=paymentCard&seq=${storeSeq}&eventSeq=${vm.$route.query.eventSeq}`;
                  // payment.children[12].value = `http://192.168.0.2:9090/payment2Web?host=${location.host}&url=paymentCard&seq=${storeSeq}&eventSeq=${vm.$route.query.eventSeq}`
                  // 결제실패 시 이동 페이지
                  payment.children[13].value = `https://sery.co.kr/payment2Web?host=${location.host}&url=productBasket&seq=${storeSeq}&eventSeq=${vm.$route.query.eventSeq}`;
                  // payment.children[13].value = `http://192.168.0.2:9090/payment2Web?host=${location.host}&url=productBasket&seq=${storeSeq}&eventSeq=${vm.$route.query.eventSeq}`
                } else {
                  // 결제성공 시 이동 페이지
                  payment.children[12].value = `https://sery.co.kr/payment2Web?host=${location.host}&url=paymentCard&seq=${storeSeq}`;
                  // payment.children[12].value = `http://192.168.0.2:9090/payment2Web?host=${location.host}&url=paymentCard&seq=${storeSeq}`
                  // 결제실패 시 이동 페이지
                  payment.children[13].value = `https://sery.co.kr/payment2Web?host=${location.host}&url=productBasket&seq=${storeSeq}`;
                  // payment.children[13].value = `http://192.168.0.2:9090/payment2Web?host=${location.host}&url=productBasket&seq=${storeSeq}`
                }
                payment.action = 'https://sery.co.kr/payment2Card';
                // payment.action = 'http://192.168.0.2:9090/payment2Card'
                payment.submit();
                return;
              } else {
                alert('결제 중 오류가 발생했습니다.\n다시 시도해주세요.');
              }
            }
          }
          // 그 외
          // 결제상품 장바구니 비우기
          localStorage.removeItem(vm.key);
          localStorage.setItem(vm.key, JSON.stringify(productBasket));
          if (!vm.$empty(work1)) {
            obj = {
              orderSeq: `${uuid}`,
              storeSeq: storeSeq,
              userSeq: userSeq,
              deliveryInfo: JSON.stringify(deliveryInfo),
              orderDate: vm.$dayjs().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
              paymentType: Number(vm.payValue),
              deliveryType: 1,
              memo: vm.$store.state.customerMemo,
              orderPrice: Number(vm.totalValue) + Number(vm.deliveryCharge),
              deliveryPrice: Number(vm.deliveryCharge),
              orderState: 1,
              deliveryName: '',
              deliveryCode: 0,
              deliveryNo: '',
              receiveCode: '',
              detailInfo: work1,
              storeName: vm.$store.state.storeInfo.STORE_NAME,
              userName: userName,
              minPromoCost: vm.$store.state.storeDeliveryInfo.MIN_PROMO_COST,
              cancelReason: '',
              cancelReasonDetail: '',
            };
            // data.push(obj)
            order = await API.graphql(
              graphqlOperation(mutations.createSeryOrderInfo, {
                input: obj,
              })
            );
            if (!vm.$empty(order)) {
              vm.selectProduct = [];
              obj.orderNo = orderNo;
              var updateObj = {
                orderSeq: obj.orderSeq,
                storeSeq: obj.storeSeq,
                userSeq: obj.userSeq,
                deliveryInfo: obj.deliveryInfo,
                orderDate: obj.orderDate,
                paymentType: obj.paymentType,
                deliveryType: obj.deliveryType,
                memo: obj.memo,
                orderNo: obj.orderNo,
                orderPrice: obj.orderPrice,
                deliveryPrice: obj.deliveryPrice,
                orderState: obj.orderState,
                deliveryName: obj.deliveryName,
                deliveryCode: obj.deliveryCode,
                deliveryNo: obj.deliveryNo,
                receiveCode: obj.receiveCode,
                bookingTime: obj.bookingTime,
                detailInfo: obj.detailInfo,
                deliveryTime: obj.deliveryTime,
                doneTime: obj.doneTime,
                riderId: obj.riderId,
                cancelReason: obj.cancelReason,
                // storeName: obj.storeName,
                cancelReasonDetail: obj.cancelReasonDetail,
              };
              // console.log('updateObj:::', updateObj)
              await API.graphql(
                graphqlOperation(mutations.updateSeryOrderInfo, {
                  input: updateObj,
                })
              );
              // console.log('success input order:::', update)
              vm.$store.commit('getBasketCnt', JSON.stringify(productBasket));
              if (!vm.$empty(vm.$route.query.eventSeq)) {
                axios({
                  method: 'patch',
                  url: `${process.env.API}/smart-view-event/orderCount/${vm.$route.query.eventSeq}`,
                }).then((response) => {
                  console.log(response);
                });
              }
              // 주문내용 라이브채팅 추가
              // console.log('address :::::', deliveryInfo)
              const addressStringArray = deliveryInfo.receiveAddress.split(' ');
              const data = {
                storeSeq: vm.$route.query.seq,
                sK: `CHAT#LIVE#${vm.$dayjs().format('YYYYMMDDHHmmss')}`,
                datetime: vm.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
                contents: `${deliveryInfo.receivePhone1.substr(-4)}님이 주문했어요.(${addressStringArray[2]})`,
                name: '주문',
                type: 'live_order',
                roomType: 'live',
              };
              await API.graphql({
                query: mutations.createStoreQnaInfoTable,
                variables: { input: data },
              });
              sendPush();
              // 주문접수내용 텔레그램 추가
              sendTelegram();
              alert('주문이 접수되었습니다.');
              vm.moveRouter('orderProcessList');
            }
          } else {
            console.log('payment ::::: 3-2');
            // alert('err')
          }
        } catch (error) {
          alert('주문 중 오류가 발생했습니다.\n인터넷 연결을 확인 후 다시 시도해주세요.');
          vm.$gtag.event('주문_오류', {
            event_category: vm.$route.query.seq,
            event_label: error,
          });
        } finally {
          vm.$store.state.isLoading = false;
        }
        function preWork() {
          return new Promise((resolve, reject) => {
            var data = [];
            try {
              for (let i = 0; i < product.length; i++) {
                var x = product[i];
                if (!vm.$empty(productBasket)) {
                  var index = productBasket.findIndex((data) => data.barcode === x.barcode);
                  if (index !== -1) {
                    productBasket.splice(index, 1);
                  }
                } else {
                  console.log('장바구니에 해당 상품 없음');
                }
                var obj = {
                  eventInfo: {
                    badgeInfoItem: !vm.$empty(x.badgeInfo) ? x.badgeInfo : {},
                    badgeList: !vm.$empty(x.badgeList) ? x.badgeList : [],
                    backgroundUrl: '',
                    barcode: x.barcode,
                    cancelList: [],
                    commentCount: 0,
                    costPrice: x.cost_price,
                    couponPublishNum: 0,
                    deliveryFlag: 1,
                    deliveryPrice: null,
                    endDate: null,
                    endPuter: 30,
                    endTime: null,
                    event: 0,
                    eventList: [],
                    eventTotalCount: 0,
                    failCode: '',
                    goodCount: 0,
                    imageItems: [
                      {
                        failCode: '',
                        imageUrl: x.image_url,
                        imageUrlFull: x.image_url,
                        result: '',
                      },
                    ],
                    imageUrl: x.image_url,
                    imageSeq: 0,
                    like_list: [],
                    likeUp: 0,
                    linkSeq: 0,
                    memo: x.name,
                    name: x.name,
                    optionList: [],
                    paymentFlag: 3,
                    paymentType: Number(paymentType),
                    result: '',
                    sellPrice: x.sell_price,
                    sellingPrice: x.sell_price,
                    seq: `${x.barcode}_${storeSeq}`,
                    sortDate: null,
                    standard: x.standard,
                    startDate: null,
                    startPuter: 0,
                    startTime: null,
                    storeLogo: x.store,
                    storeName: storeName,
                    storeSeq: storeSeq,
                    tags: [],
                    title: x.name,
                    uprightFlag: 0,
                  },
                  eventSeq: `'${x.barcode}_${storeSeq}'`,
                  orderQty: `${x.order_qty}`,
                  orderSeq: uuid,
                };
                data.push(JSON.stringify(obj));
              }
              resolve(data);
            } catch (err) {
              console.log('preWork :::::', err);
            }
          });
        }
        function sendTelegram() {
          vm.$axios({
            method: 'get',
            url: `https://n18xzda2u4.execute-api.ap-northeast-2.amazonaws.com/prod/new-order`,
            // url: `http://192.168.0.2:3014/new-order`,
            params: {
              storeName: `[WEB]${vm.$store.state.storeInfo.STORE_NAME}`,
              storeSeq: vm.$store.state.storeInfo.STORE_SEQ,
              orderDate: updateObj.orderDate,
              msg: `주문이 접수 되었습니다.|- 주문번호 : ${updateObj.orderNo}|- 주문일시 : ${vm.$dayjs(updateObj.orderDate).format('YYYY-MM-DD HH:mm:ss')}|- 주문금액 : ${vm.numberWithCommas(
                updateObj.orderPrice
              )}`,
            },
          });
        }
        function sendPush() {
          vm.$axios({
            method: 'post',
            url: 'https://www.sery.co.kr/store/v4/' + vm.$store.state.storeInfo.STORE_SEQ + '/orders',
            data: {
              deliveryInfo: {
                failCode: '',
                result: '',
              },
              failCode: '',
              memo: `주문이 접수 되었습니다.|- 주문번호 : ${updateObj.orderNo}|- 주문일시 : ${vm
                .$dayjs(updateObj.orderDate)
                .format('YYYY-MM-DD HH:mm:ss')}|- 주문금액 : ${vm.numberWithCommas(updateObj.orderPrice)}`,
              orderDetails: [],
              orderNo: updateObj.orderNo,
              result: '',
              storeInfo: {
                endPuter: 10,
                failCode: '',
                heloFriendCount: 0,
                result: '',
                staffCount: 0,
                startPuter: 0,
                storeDelivery: {
                  deliveryCost: 0,
                  minPromoCost: 0,
                },
              },
              storeSeq: vm.$store.state.storeInfo.STORE_SEQ,
            },
          });
        }
      }
      function chkDuplicateNum() {
        return new Promise((resolve, reject) => {
          vm.$axios({
            method: 'post',
            url: `${process.env.API}/chkDuplicateNum/${vm.$route.query.seq}/${vm.$store.state.customerPhone}`,
            data: {
              name: vm.$store.state.customerName,
              zipCode: vm.$store.state.zipCode,
              addr1: vm.$store.state.addr1,
              addr2: vm.$store.state.addr2,
            },
          }).then((response) => {
            resolve(response.data);
          });
        });
      }
      function deliveryDistanceCheck(storeSeq, maxDistance, address) {
        return new Promise((resolve, reject) => {
          vm.$axios({
            method: 'get',
            url: `https://storeDelivery.sery.co.kr/${storeSeq}/deliveryPossable?maxDistance=${maxDistance}&address=${encodeURI(address)}`,
            // url: `http://192.168.0.2:3013/${storeSeq}/deliveryPossable?maxDistance=${maxDistance}&address=${encodeURI(address)}`
          })
            .then((response) => {
              resolve(response.data.result);
            })
            .catch((error) => {
              console.log(error);
              resolve(false);
            });
        });
      }
    },
    /** ======================================
     *
     */
    getBasket() {
      console.log('getBasket 1 :::::');
      const vm = this;
      async.waterfall(
        [
          (callback) => {
            vm.dataList = [];
            let localData = JSON.parse(localStorage.getItem(vm.key));
            console.log('getBasket 2 :::::', localData);
            if (!vm.$empty(localData)) {
              vm.storeSeqList = vm.$_.uniq(vm.$_.map(localData, 'storeSeq'));
              console.log('getBasket 3 :::::', vm.storeSeqList);
              vm.storeSeqList.forEach((seq) => {
                var filterData = vm.$_.filter(localData, ['storeSeq', seq]);
                console.log('getBasket 4 :::::', filterData);
                vm.dataList.push(...filterData);
              });
              callback(null);
            } else {
              callback(null);
            }
          },
          (callback) => {
            var cookies = vm.$cookies.get('kakaoLogin');
            if (!vm.$empty(cookies) && !vm.$empty(vm.$store.state.userData)) {
              vm.getTeryInfo(cookies.id);
              callback(null);
            } else {
              callback(null);
            }
          },
        ],
        (err, result) => {
          if (!err) {
            vm.loading = 1;
            console.log('getBasket 5 :::::', vm.loading, vm.dataList.length);
            if (!vm.$empty(vm.dataList)) {
              vm.chkProductState(0);
              vm.getTotal();
            } else {
              vm.$router.go(-1);
            }
          } else {
            console.log('getBasket 6 :::::', err);
          }
        }
      );
    },
    async chkProductState(val) {
      // 0: 판매중지, 1: 완판
      console.log('chkProductState :::::', val);
      const vm = this;
      var barcodeList = '';
      var newProductList = '';
      barcodeList = await getBarcode();
      newProductList = await getProductData();
      const result = await compareProduct(vm.dataList, newProductList);
      if (result[1] === 2) {
        // 행사기간 종료
        alert(`행사기간이 종료된 상품(${result[2]})이 있습니다.\n확인 후 다시 주문해주세요.`);
        // vm.goHome()
        return;
      }
      if (result[1] === 3) {
        // 삭제된 상품
        alert(`행사진행 중이 아닌 상품(${result[2]})이 있습니다.\n확인 후 다시 주문해주세요.`);
        // vm.goHome()
        return;
      }
      vm.dataList = result[0];
      if (result[1] === 1) {
        alert(`금액이 변경된 상품이 있습니다.\n확인 후 다시 주문해주세요.`);
        vm.getTotal();
        return;
      }
      if (val === 0) {
        console.log('페이지 최초 접속 상품체크', vm.dataList);
      } else {
        console.log('상품주문');
        vm.insertOrder();
      }
      function getBarcode() {
        var result = '';
        return new Promise((resolve, reject) => {
          for (let i = 0; i < vm.dataList.length; i++) {
            var x = vm.dataList[i];
            if (result === '') {
              result = x.barcode;
            } else {
              result = result + ' ' + x.barcode;
            }
          }
          resolve(result);
        });
      }
      function getProductData() {
        return new Promise((resolve, reject) => {
          var query = {
            from: 0,
            size: 100,
            sort: {
              status: 'desc',
              reg_date: 'desc',
            },
            _source: ['barcode', 'store_seq', 'status', 'event_list'],
            query: {
              bool: {
                must: [
                  {
                    match: {
                      store_seq: vm.$route.query.seq,
                    },
                  },
                  {
                    match: {
                      barcode: barcodeList,
                    },
                  },
                ],
              },
            },
          };
          vm.$axios({
            method: 'post',
            headers: {
              'content-type': 'application/json',
              Authorization: 'Basic Y3J1ZDpUb25vNTAwMyFAIyQ=',
            },
            url: `https://es.sery.co.kr/product/_search`,
            data: JSON.stringify(query),
          }).then((response) => {
            resolve(response.data.hits.hits);
          });
        });
      }
      function compareProduct(original, newData) {
        return new Promise((resolve, reject) => {
          const newBasketInfo = [];
          let check = false;
          for (let i = 0; i < original.length; i++) {
            const x = original[i];
            const index = newData.findIndex((newProduct) => newProduct._source.barcode === x.barcode || String(newProduct._source.barcode) === String(x.barcode));
            console.log('compareProduct index1 :::::', index, x.barcode);
            if (index > -1) {
              x.status = Number(newData[index]._source.status);
              if (!vm.$empty(x.batchSeq)) {
                const index2 = newData[index]._source.event_list.findIndex(
                  (newProduct) => Number(newProduct.batch_seq) === Number(x.batchSeq) || Number(newProduct.batchSeq) === Number(x.batchSeq)
                );
                console.log('compareProduct index2 :::::', index2, newData[index]._source.event_list[index2]);
                if (index2 > -1) {
                  // 행사기간 체크
                  if (
                    newData[index]._source.event_list[index2].start_date > vm.$dayjs().format('YYYYMMDD') ||
                    newData[index]._source.event_list[index2].end_date < vm.$dayjs().format('YYYYMMDD')
                  ) {
                    resolve([null, 2, x.name]);
                  }
                  if (
                    !Number.isNaN(x.costPrice) &&
                    x.costPrice !== '' &&
                    Number(x.costPrice) !== Number(String(newData[index]._source.event_list[index2].cost_price || '') || String(newData[index]._source.event_list[index2].costPrice || ''))
                  ) {
                    x.costPrice = Number(String(newData[index]._source.event_list[index2].cost_price || '') || String(newData[index]._source.event_list[index2].costPrice || ''));
                    check = true;
                    console.log('compareProduct change1 :::::', x.costPrice);
                  }
                  if (
                    !Number.isNaN(x.cost_price) &&
                    x.cost_price !== '' &&
                    Number(x.cost_price) !== Number(String(newData[index]._source.event_list[index2].cost_price || '') || String(newData[index]._source.event_list[index2].costPrice || ''))
                  ) {
                    x.cost_price = Number(String(newData[index]._source.event_list[index2].cost_price || '') || String(newData[index]._source.event_list[index2].costPrice || ''));
                    check = true;
                    console.log('compareProduct change2 :::::', x.cost_price);
                  }
                  if (
                    Number(x.sellPrice) !== Number(String(newData[index]._source.event_list[index2].sell_price || '') || String(newData[index]._source.event_list[index2].sellPrice || ''))
                  ) {
                    x.sellPrice = Number(String(newData[index]._source.event_list[index2].sell_price || '') || String(newData[index]._source.event_list[index2].sellPrice || ''));
                    check = true;
                    console.log('compareProduct change3 :::::', x.sellPrice);
                  }
                  if (
                    Number(x.sell_price) !== Number(String(newData[index]._source.event_list[index2].sell_price || '') || String(newData[index]._source.event_list[index2].sellPrice || ''))
                  ) {
                    x.sell_price = Number(String(newData[index]._source.event_list[index2].sell_price || '') || String(newData[index]._source.event_list[index2].sellPrice || ''));
                    check = true;
                    console.log('compareProduct change4 :::::', x.sell_price);
                  }
                  newBasketInfo.push(x);
                } else {
                  //  행사진행 중이 아닌 상품
                  resolve([null, 3, x.name]);
                }
              } else {
                newBasketInfo.push(x);
              }
            }
          }
          console.log('compareProduct :::::', newBasketInfo);
          if (check) {
            console.log('checkProductPrice end :::::', check, newBasketInfo);
            resolve([newBasketInfo, 1]);
          } else {
            console.log('checkProductPrice end :::::', check, newBasketInfo);
            resolve([newBasketInfo, 0]);
          }
        });
      }
    },
    async getTotal() {
      const vm = this;
      if (vm.$empty(vm.storeDeliveryInfo) || vm.$empty(vm.storeDeliveryInfo.result)) {
        setTimeout(() => {
          console.log('getTotal1 :::::', null);
          vm.getTotal();
        }, 1000);
      } else {
        console.log('getTotal2 :::::', vm.storeDeliveryInfo);
        console.log('getTotal3 :::::', vm.dataList);
        // this.storeInfoList = await getStoreInfo()
        vm.totalValue = await getProductTotal();
        if (Number(vm.payValue) !== 7 && Number(vm.payValue) !== 8) {
          vm.deliveryCharge = await sumDeliveryCharge();
        } else {
          vm.deliveryCharge = 0;
        }
        // this.deliveryFlag = await chkDelivery()
        // this.$cookies.set('storeDeliveryInfo', JSON.stringify(this.storeInfoList))
      }
      function getProductTotal() {
        var result = 0;
        return new Promise((resolve, reject) => {
          if (!vm.$empty(vm.selectProduct)) {
            for (let i = 0; i < vm.selectProduct.length; i++) {
              var data = vm.selectProduct[i];
              result += data.sell_price * data.order_qty;
            }
            resolve(result);
          } else {
            resolve(0);
          }
        });
      }
      function sumDeliveryCharge() {
        // var result = vm.totalValue
        // var deliveryData = vm.storeInfoList
        // var cost = 0
        return new Promise((resolve, reject) => {
          if (vm.totalValue < vm.storeDeliveryInfo.MIN_PROMO_COST) {
            // 최소주문금액 이하
            vm.deliveryFlag = 0;
          } else {
            // 이상
            vm.deliveryFlag = 1;
            if (!vm.$empty(vm.storeDeliveryInfo.result.list) && vm.storeDeliveryInfo.result.list.length > 0) {
              for (let i = 0; i < vm.storeDeliveryInfo.result.list.length; i++) {
                if (vm.totalValue < vm.storeDeliveryInfo.result.list[i].minAmount) {
                  if (i === 0) {
                    vm.storeDeliveryInfo.DELIVERY_COST = parseInt(vm.storeDeliveryInfo.result.defaultList.charge);
                    break;
                  }
                  if (i !== 0) {
                    vm.storeDeliveryInfo.DELIVERY_COST = parseInt(vm.storeDeliveryInfo.result.list[i - 1].charge);
                  }
                  break;
                } else {
                  vm.storeDeliveryInfo.DELIVERY_COST = parseInt(vm.storeDeliveryInfo.result.list[i].charge);
                }
              }
            }
            resolve(vm.storeDeliveryInfo.DELIVERY_COST);
          }
        });
      }
    },
    checkAll() {
      console.log('checkAll :::::');
      this.allCheck = true;
      if (this.$refs.allCheck.checked) {
        this.$store.state.footFlag = 1;
        for (let i = 0; i < this.dataList.length; i++) {
          document.getElementById(`productChk${i}`).checked = true;
          var barcodeIndex = this.selectProduct.indexOf(this.dataList[i].barcode);
          var storeSeqIndex = this.selectProduct.indexOf(this.dataList[i].storeSeq);
          if (barcodeIndex === -1 && storeSeqIndex === -1) {
            this.selectProduct.push(this.dataList[i]);
          }
        }
      } else {
        this.selectProduct = [];
        this.$store.state.footFlag = 0;
        for (let i = 0; i < this.dataList.length; i++) {
          document.getElementById(`productChk${i}`).checked = false;
        }
      }
      this.getTotal();
    },
    checkProduct(row) {
      console.log('checkProduct :::::');
      this.allCheck = false;
      var barcodeIndex = this.selectProduct.findIndex((x) => x.barcode === row.barcode);
      var nameIndex = this.selectProduct.findIndex((x) => x.name === row.name);
      if (barcodeIndex === -1 && nameIndex === -1) {
        this.$store.state.footFlag = 1;
        this.selectProduct.push(row);
        console.log('push:::', this.selectProduct);
        for (let i = 0; i < this.dataList.length; i++) {
          if (document.getElementById(`productChk${i}`).checked !== true) {
            console.log('중간에 뭐하나 있음');
            this.allCheck = false;
            break;
          } else {
            this.allCheck = true;
          }
        }
      } else {
        if (barcodeIndex === nameIndex) {
          this.selectProduct.splice(barcodeIndex, 1);
          console.log('pop:::', this.selectProduct);
          if (this.$empty(this.selectProduct)) {
            this.$store.state.footFlag = 0;
          }
        }
      }
      this.getTotal();
    },
    // changeFootFlag () {
    //   if (this.footFlag === 1) {
    //     this.footFlag = 0
    //   } else {
    //     this.footFlag = 1
    //   }
    // },
    changeStatus(val) {
      var result = '';
      switch (val) {
        case 0:
          result = ' (배달불가)';
          break;
        case 1:
          result = ' (배달불가)';
          break;
      }
      return result;
    },
    async deleteBasket(val) {
      const vm = this;
      var preDelete = confirm(`${val.name}\n상품을 삭제하시겠습니까?`);
      if (preDelete) {
        var d1 = await deleteBasket1();
        var d2 = await deleteBasket2();
        localStorage.setItem(vm.key, JSON.stringify(vm.dataList));
        console.log(`result::: ${d1}, ${d2}`);
        if (!this.$empty(this.dataList)) {
          this.getTotal();
        } else {
          alert('장바구니가 비었습니다.');
          this.$router.go(-1);
        }
      } else {
        console.log('error:::: deleteBasket');
      }
      function deleteBasket1() {
        return new Promise((resolve, reject) => {
          var index = vm.dataList.findIndex((x) => x.name === val.name);
          if (index !== -1) {
            vm.dataList.splice(index, 1);
            resolve('success d1');
          } else {
            // alert(`empty`)
            resolve('error');
          }
        });
      }
      function deleteBasket2() {
        return new Promise((resolve, reject) => {
          var index = vm.selectProduct.findIndex((x) => x.name === val.name);
          if (index !== -1) {
            vm.selectProduct.splice(index, 1);
            resolve('success d2');
          } else {
            // alert(`empty`)
            resolve('error');
          }
        });
      }
    },
    removeBasket() {
      if (!this.$empty(this.selectProduct)) {
        var up = confirm('선택한 모든 상품을\n장바구니에서 삭제하시겠습니까?');
        if (up) {
          async.waterfall([
            (callback) => {
              for (let i = 0; i < this.selectProduct.length; i++) {
                var barcodeIndex = this.dataList.findIndex((x) => x.barcode === this.selectProduct[i].barcode);
                var nameIndex = this.dataList.findIndex((x) => x.name === this.selectProduct[i].name);
                console.log('barcode:::', barcodeIndex);
                console.log('name:::', nameIndex);
                if (barcodeIndex !== -1 && nameIndex !== -1) {
                  if (barcodeIndex === nameIndex) {
                    this.dataList.splice(barcodeIndex, 1);
                    this.$nextTick(() => {
                      console.log('click');
                      if (!this.$empty(this.$refs.allCheck)) {
                        this.$refs.allCheck.click();
                        this.$refs.allCheck.click();
                      }
                    });
                    if (this.selectProduct.length - 1 === i) {
                      callback(null);
                    }
                  }
                }
              }
            },
            (callback) => {
              if (this.dataList.length === 0) {
                alert('장바구니가 비었습니다.');
                this.selectProduct = [];
                var tmp = JSON.stringify(this.dataList);
                console.log('tmp:::', tmp);
                localStorage.setItem(this.key, tmp);
                this.$store.commit('getBasketCnt', tmp);
                this.getBasket();
                this.$router.go(-1);
              }
              callback(null);
            },
          ]);
        }
      } else {
        alert('상품을 선택해 주세요.');
      }
    },
    impossibleOrder() {
      alert(`최소주문금액을 채워주세요.`);
    },
    goHome() {
      this.moveRouter('storeMain');
    },
    goPrePay() {
      if (this.$empty(this.$cookies.get('kakaoLogin'))) {
        console.log('1111');
        this.$store.state.isLoading = true;
        loginWithKakao();
      } else {
        var statusFilter0 = this.$_.filter(this.selectProduct, { status: 0 });
        var statusFilter1 = this.$_.filter(this.selectProduct, { status: 1 });
        if (!this.$empty(statusFilter0) || !this.$empty(statusFilter1)) {
          alert('상태가 변경된 상품이 있습니다.\n다시 한번 확인해주세요.');
        } else {
          this.$store.state.prePay = this.$_.cloneDeep(this.selectProduct);
          this.$store.state.storeSeqList = this.$_.cloneDeep(this.storeSeqList);
          // this.$store.state.storeInfoList = this.$_.cloneDeep(this.storeInfoList)
          this.moveRouter('prePay');
        }
      }
    },
    getTeryInfo(key) {
      this.$axios({
        method: 'get',
        url: `${process.env.API}/getTeryInfo/key/${key}`,
      }).then((response) => {
        console.log('getTeryInfo:::', response);
        if (!this.$empty(response)) {
          this.$store.state.userData = response.data[0];
          const userData = JSON.stringify(response.data[0]);
          this.$cookies.set('userData', userData, '30min');
          this.$cookies.set('userSeq', userData.USER_SEQ);
        } else {
          console.log('getTeryInfo err');
        }
      });
    },
    changeQuantity(i, oper) {
      const vm = this;
      console.log('changeQuantity :::::');
      let index = -99;
      if (oper === 'p') {
        if (!this.checkAndAlertBadgeQtyLimit(this.dataList[i], this.dataList[i].order_qty + 1)) return;
        this.dataList[i].order_qty += 1;
        if (document.getElementById(`productChk${i}`) === true) {
          index = this.selectProduct.findIndex((x) => x.barcode === this.dataList[i].barcode);
          if (index !== -1) {
            this.selectProduct[index].order_qty = this.dataList[i].order_qty;
          }
        }
        this.$nextTick(() => {
          vm.getTotal();
        });
      } else {
        if (this.dataList[i].order_qty > 1) {
          this.dataList[i].order_qty -= 1;
          if (document.getElementById(`productChk${i}`) === true) {
            index = this.selectProduct.findIndex((x) => x.barcode === this.dataList[i].barcode);
            if (index !== -1) {
              this.selectProduct[index].order_qty = this.dataList[i].order_qty;
            }
          }
        } else {
          console.log('최소수량');
        }
        this.$nextTick(() => {
          vm.getTotal();
        });
      }
    },
    returnStoreName(val) {
      // var result = this.$_.filter(this.$store.state.storeInfo, ['STORE_SEQ', val])
      if (this.$store.state.storeInfo.STORE_SEQ === val) {
        return this.$store.state.storeInfo.STORE_NAME;
      } else {
        return '';
      }
    },
    getUUID() {
      // UUID v4 generator in JavaScript (RFC4122 compliant)
      var uuid = '';
      var i, random;
      for (i = 0; i < 32; i++) {
        random = (Math.random() * 16) | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
          uuid += '-';
        }
        uuid += (i === 12 ? 4 : i === 16 ? (random & 3) | 8 : random).toString(16);
      }
      return uuid;
    },
    numberWithCommas(x, flag) {
      if (flag === 0) {
        if (!x) {
          return '0';
        } else if (x === 0 || x === '0') {
          return '';
        } else {
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
      } else {
        if (!x) {
          return '0원';
        } else if (x === 0 || x === '0') {
          return '';
        } else {
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원';
        }
      }
    },
    searchCustomer() {
      const vm = this;
      if (vm.$empty(vm.selectAddress) && !vm.$empty(vm.$store.state.customerPhone) && vm.$store.state.customerPhone.length === 11) {
        vm.$modal.hide('insertPhone');
        vm.$gtag.event('전화번호_입력', {
          event_category: vm.$route.query.seq,
          event_label: vm.$cookies.get('userSeq'),
          value: vm.$store.state.customerPhone,
        });
        vm.$axios({
          method: 'get',
          url: `${process.env.API}/getAddress/phone/${vm.$store.state.customerPhone}`,
        }).then((response) => {
          if (!vm.$empty(response.data) && response.data !== 'empty') {
            vm.$store.state.addressList = vm.$_.cloneDeep(response.data);
            vm.$modal.show('selectAddr');
          }
        });
      }
    },
    openSearchModal() {
      const vm = this;
      vm.$modal.show('searchAddr');
      vm.$nextTick(() => {
        vm.$refs.searchAddrInput.focus();
      });
    },
    searchBack() {
      const vm = this;
      switch (vm.searchIndex) {
        case 0:
          vm.$modal.hide('searchAddr');
          break;
        case 1:
          vm.searchIndex = 0;
          break;
        case 2:
          break;
      }
    },
    searchAddress: _.debounce(function (e) {
      const vm = this;
      vm.clickAddress = e.target.value;
      if (vm.clickAddress.length > 0) {
        // 특수문자 제거
        var expText = /[%=>< ]/;
        if (expText.test(vm.clickAddress) === true) {
          vm.clickAddress = vm.clickAddress.split(expText).join('');
        }

        // 특정문자열(sql예약어의 앞뒤공백포함) 제거
        var sqlArray = [
          // sql 예약어
          'OR',
          'SELECT',
          'INSERT',
          'DELETE',
          'UPDATE',
          'CREATE',
          'DROP',
          'EXEC',
          'UNION',
          'FETCH',
          'DECLARE',
          'TRUNCATE',
        ];

        var regex;
        for (var i = 0; i < sqlArray.length; i++) {
          regex = new RegExp(sqlArray[i], 'gi');

          if (regex.test(vm.clickAddress)) {
            vm.clickAddress = vm.clickAddress.replace(regex, '');
          }
        }
      }
      if (vm.$empty(vm.clickAddress)) {
        return;
      }
      vm.$axios({
        method: 'get',
        url: `https://www.juso.go.kr/addrlink/addrLinkApi.do?confmKey=U01TX0FVVEgyMDIxMTIwMzE1MjYwMDExMTk4OTU=&currentPage=1&countPerPage=100&keyword=${vm.clickAddress}&resultType=json`,
      }).then((response) => {
        console.log('address :::::', vm.clickAddress, response);
        vm.addressList = [];
        if (!vm.$empty(response.data) && response.data.results.common.errorMessage === '정상') {
          if (vm.$empty(response.data.results.juso)) {
            vm.addressList.push({ zipCode: '', addr: '찾으시는 주소가 없습니다.<br/>수정 후 다시 검색 바랍니다.' });
            return;
          }
          vm.addressList = vm.addressList.filter(function (item) {
            return item.addr !== '찾으시는 주소가 없습니다.<br/>수정 후 다시 검색 바랍니다.';
          });
          response.data.results.juso.forEach((juso) => {
            vm.addressList.push({ zipCode: juso.zipNo, addr: juso.roadAddr });
          });
        } else {
          vm.addressList.push({ zipCode: '', addr: '찾으시는 주소가 없습니다.<br/>수정 후 다시 검색 바랍니다.' });
        }
      });
    }, 700),
    selectRoadAddress(clickAddress) {
      const vm = this;
      if (clickAddress !== '찾으시는 주소가 없습니다.<br/>수정 후 다시 검색 바랍니다.') {
        vm.$store.state.addr1 = clickAddress;
        vm.searchIndex = 1;
        vm.$store.state.addr2 = '';
      }
    },
    searchDoneAddress() {
      const vm = this;
      vm.$store.state.fullAddr = vm.$store.state.addr1 + ' ' + vm.$store.state.addr2;
      vm.clickAddress = '';
      vm.addressList = [];
      vm.searchIndex = 0;
      vm.$modal.hide('searchAddr');
      vm.$gtag.event('신규_주소입력', {
        event_category: vm.$route.query.seq,
        event_label: vm.$cookies.get('userSeq'),
        value: vm.$store.state.fullAddr,
      });
    },
    checkPacking() {
      const vm = this;
      const storeDeliveryInfo = vm.$store.state.storeDeliveryInfo;
      if (
        !vm.$empty(storeDeliveryInfo.result.type0) &&
        !vm.$empty(storeDeliveryInfo.result.type1) &&
        !vm.$empty(storeDeliveryInfo.result.type2) &&
        !vm.$empty(storeDeliveryInfo.result.type3) &&
        !vm.$empty(storeDeliveryInfo.result.type4) &&
        Number(storeDeliveryInfo.result.type0) === 0 &&
        Number(storeDeliveryInfo.result.type1) === 0 &&
        Number(storeDeliveryInfo.result.type2) === 0
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('/css/productBasket.css');

.badge-image {
  position: relative;
  width: 30%;
  max-width: 100px;
  top: 0;
  left: 10px;
  object-fit: contain;
  &--1 {
    left: -5%;
  }
  &--2 {
    left: -15%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/productBasket/productBasket.vue